/**
 * 緑背景にかぶる時はロゴとナビの色を反転
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

/**
 * ナビゲーションリンクとロゴの色を変更する関数
 *
 * @param {string} color - 適用する色のCSS文字列（例: '#fff'）。空文字列で元の色に戻す。
 */
function toggleColor( color ) {
	// CSS変数'--gnav-under-line-color'を更新して下線の色を変更
	document.documentElement.style.setProperty(
		'--gnav-under-line-color',
		color
	);

	// ナビゲーションリンクの色を変更
	gsap.to(
		'.wp-block-cb-site-gnav > nav > ul > li > a, .wp-block-cb-site-gnav .wp-block-navigation__submenu-icon svg',
		{
			color: color,
			duration: 0.1,
		}
	);
	//ロゴの色を反転
	gsap.to( '.wp-block-cb-site-header__logo img', {
		filter: color === '#fff' ? 'brightness(0) invert(1)' : 'none',
		duration: 0.5,
	} );
}

// .js-color-reverse-triggerがページ内に存在するか確認
const triggerElement = document.querySelector( '.js-color-reverse-trigger' );
if ( triggerElement ) {
	ScrollTrigger.create( {
		trigger: '.js-color-reverse-trigger',
		start: 'top top',
		end: 'bottom top',
		onEnter: () => toggleColor( '#fff' ),
		onLeave: () => toggleColor( '' ),
		onEnterBack: () => toggleColor( '#fff' ),
		onLeaveBack: () => toggleColor( '' ),
		//markers: true,
	} );
}
